// extracted by mini-css-extract-plugin
export default {"dropMenu":"drop-menu__AblJF2DY"};